// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"sy_a bhr_b bhr_bj","StrollerbaseBanner__hint":"sy_b bhr_vh","StrollerbaseBanner__link":"sy_c"};